<template>
    <BaseWidget :title="widget.title" :title-url="widget.titleUrl">
        <AppButton
            :href="button.url"
            element="a"
            desired-action
            v-for="button in widget.content.buttons"
            :key="button.url"
        >
            {{ button.text_button }}
        </AppButton>
    </BaseWidget>
</template>

<script>
import BaseWidget from '@/components/Widgets/BaseWidget.vue';
import AppButton from '@/components/AppButton.vue';

export default {
    name: 'MultipleButtonsWidget',
    props: {
        widget: {
            required: true,
            type: Object,
        },
    },
    components: {
        AppButton,
        BaseWidget,
    },
};
</script>
